import { Col, Grid, Row } from 'react-bootstrap'
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor'
import { getMXDewarsByProposal, getUpdateSampleChangerLocationURL } from '../../api/ispyb'

import BootstrapTable2 from 'react-bootstrap-table-next'
import { CamembertContainer } from '../../components/Camembert/Camembert.container'
import { ERROR_MESSAGE_TYPE } from '../../constants/UserMessages'
import Loader from 'react-loader-advanced'
import MXNavigationContainer from './MXNavigationContainer'
import MXStepContainer from './MXStepContainer'
import PropTypes from 'prop-types'
import React from 'react'
import UserMessage from '../../components/saxs/UserMessage'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import { setBreadCrumbs } from '../../actions/breadcrumbs'

require('./mxprepareexperiment.css')

class MXLoadSampleChanger extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 2,
      error: null,
      fetched: false,
      fetching: true,
      response: null,
      selectedShipment: null,
    }
    this.fetchingData = false
  }

  displayProcessing(data) {
    const output = []
    const l = data.length
    let i
    for (i = 0; i < l; i++) {
      if (data[i].shippingStatus === 'processing') {
        if (data[i].capacity === 16) {
          data[i].containerType = 'Unipuck'
        }
        output.push(data[i])
      }
    }
    return output
  }

  componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate() {
    if (this.props.user && this.props.user.token && !this.fetchingData) {
      this.fetchingData = true
      this.fetchData()
    }
  }

  fetchData() {
    const _this = this
    axios({
      method: 'GET',
      url: getMXDewarsByProposal(this.props.user, this.props.application.activeProposal.name),
    }).then(
      response => {
        _this.setState({
          response: response.data,
          filtered: _this.displayProcessing(response.data),
          fetching: false,
          fetched: true,
          url: this.props.url,
          step: 2,
        })
      },
      error => {
        _this.setState({ error: error, fetching: false, fetched: false, step: 2 })
      }
    )
  }

  render() {
    const _this = this

    if (!this.props.user.username || !this.props.user.token) {
      return null
    }
    if (this.state.fetching) {
      return (
        <Loader show={this.state.fetching} message="Fetching data">
          ..
        </Loader>
      )
    }

    if (this.state.fetched === false && this.state.fetching === false) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <UserMessage type={ERROR_MESSAGE_TYPE} message="Retrieval of the data failed." />
            </Col>
          </Row>
        </Grid>
      )
    }

    const rowEvents = {
      onClick: (e, row) => {
        _this.setState({
          selectedShipment: row,
        })
      },
    }

    return (
      <div>
        <MXStepContainer step={this.state.step} />
        <div className="text-container-default">
          <label>Loaded or to be Loaded on MxCube</label>
        </div>

        <Grid fluid>
          <Row>
            <Col lg={6}>
              <div className="rowC">
                <BootstrapTable2
                  rowEvents={rowEvents}
                  pageOptions={{
                    sizePerPage: 25,
                  }}
                  selectRow={{
                    mode: 'radio',
                    clickToSelect: true,
                    clickToEdit: true,
                    style: {
                      background: '#222f3e',
                      color: 'white',
                    },
                  }}
                  hover
                  striped
                  search={false}
                  keyField="containerId"
                  data={this.state.filtered}
                  columns={this.getColumns()}
                  cellEdit={cellEditFactory({
                    afterSaveCell: (oldValue, newValue, row, column) => {
                      if (column.text === 'beamline') {
                        axios({
                          url: getUpdateSampleChangerLocationURL(
                            this.props.user,
                            this.props.application.activeProposal.name,
                            row.containerId,
                            newValue
                          ),
                          method: 'POST',
                          mode: 'no-cors',
                          data: 'sampleChangerLocation=' + row.sampleChangerLocation,
                        }).then(() => {
                          this.fetchData()
                        })
                      } else if (column.text === 'position') {
                        axios({
                          url: getUpdateSampleChangerLocationURL(
                            this.props.user,
                            this.props.application.activeProposal.name,
                            row.containerId,
                            row.beamlineLocation
                          ),
                          method: 'POST',
                          mode: 'no-cors',
                          data: 'sampleChangerLocation=' + newValue,
                        }).then(() => {
                          this.fetchData()
                        })
                      }
                    },
                    mode: 'click',
                    blurToSave: true,
                  })}
                />
              </div>
            </Col>
            <Col lg={6}>
              {this.state.filtered && this.state.selectedShipment && (
                <CamembertContainer
                  fetchDataCallback={() => {
                    this.fetchData()
                  }}
                  selectedShipment={this.state.selectedShipment ? this.state.selectedShipment : this.state.filtered[0]}
                  filtered={this.state.filtered}
                  user={this.props.user}
                  username={this.props.user.username}
                  proposalName={this.props.application.activeProposal.name}
                />
              )}
            </Col>
          </Row>
        </Grid>

        <MXNavigationContainer step={this.state.step} />
      </div>
    )
  }

  getColumns() {
    return [
      {
        text: 'containerId',
        dataField: 'containerId',
        hidden: true,
      },
      {
        editable: false,
        text: 'Shipment',
        dataField: 'shippingName',
        sort: true,
        responsiveHeaderStyle: {
          xs: {
            width: '60px',
            height: '20px',
            textAlign: 'center',
          },
          sm: {
            width: '60px',
            height: '20px',
            textAlign: 'center',
          },
          md: {
            width: '60px',
            height: '20px',
            textAlign: 'center',
          },
          lg: {
            width: '60px',
            height: '20px',
            textAlign: 'center',
          },
        },
      },
      {
        text: 'Parcel',
        dataField: 'dewarCode',
        sort: true,
        editable: false,
        responsiveHeaderStyle: {
          xs: {
            width: '30px',
            textAlign: 'center',
          },
          sm: {
            width: '30px',
            textAlign: 'center',
          },
          md: {
            width: '30px',
            textAlign: 'center',
          },
          lg: {
            width: '30px',
            textAlign: 'center',
          },
        },
      },
      {
        text: 'Container',
        dataField: 'containerCode',
        sort: true,
        editable: false,
        responsiveHeaderStyle: {
          xs: {
            width: '30px',
            textAlign: 'center',
          },
          sm: {
            width: '30px',
            textAlign: 'center',
          },
          md: {
            width: '30px',
            textAlign: 'center',
          },
          lg: {
            width: '30px',
            textAlign: 'center',
          },
        },
      },
      {
        text: 'Container type',
        dataField: 'containerType',
        editable: false,
        formatter: this.containerTypeFormatter,
        formatExtraData: this,
        responsiveHeaderStyle: {
          xs: {
            width: '30px',
            textAlign: 'center',
          },
          sm: {
            width: '30px',
            textAlign: 'center',
          },
          md: {
            width: '30px',
            textAlign: 'center',
          },
          lg: {
            width: '30px',
            textAlign: 'center',
          },
        },
      },
      {
        text: 'beamline',
        dataField: 'beamlineLocation',
        editor: {
          type: Type.SELECT,
          options: [
            {
              value: 'PROXIMA1',
              label: 'PROXIMA1',
            },
            {
              value: 'PROXIMA2A',
              label: 'PROXIMA2A',
            },
          ],
        },
        formatter: this.myformatter,
        responsiveHeaderStyle: {
          xs: {
            width: '30px',
            textAlign: 'center',
          },
          sm: {
            width: '30px',
            textAlign: 'center',
          },
          md: {
            width: '30px',
            textAlign: 'center',
          },
          lg: {
            width: '30px',
            textAlign: 'center',
          },
        },
      },
      {
        text: 'position',
        dataField: 'sampleChangerLocation',
        formatExtraData: this,
        formatter: this.myformatter,
        responsiveHeaderStyle: {
          xs: {
            width: '30px',
            textAlign: 'center',
          },
          sm: {
            width: '30px',
            textAlign: 'center',
          },
          md: {
            width: '30px',
            textAlign: 'center',
          },
          lg: {
            width: '30px',
            textAlign: 'center',
          },
        },
      },
    ]
  }

  myformatter(cell) {
    if (cell === null) {
      return 'to be defined ✎'
    }

    return cell + ' ✎'
  }

  containerTypeFormatter(cell) {
    if (!cell) {
      return ''
    }
    switch (cell) {
      case 'Unipuck':
        return <kbd style={{ color: 'white', fontSize: '11px', backgroundColor: 'blue' }}>UNIPUCK</kbd>
      case 'Spinepuck':
        return <kbd style={{ color: 'black', fontSize: '11px', backgroundColor: '#CCCCCC' }}>SPINEPUCK</kbd>
      default:
        return <kbd style={{ color: 'white', fontSize: '11px', backgroundColor: '#000000' }}> {cell} </kbd>
    }
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MXLoadSampleChanger)

MXLoadSampleChanger.propTypes = {
  /** proposal number */
  proposal: PropTypes.string,
  /** session identifier */
  sessionId: PropTypes.string,
}
